import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import api from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.post("/newsletter/unsubscribe", { token }).then(() => setState("ok")).catch(() => setState("error"));
  }, [params]);

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />
      <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="unsubscribe">
        {state === "loading" && <p className="text-stone-500">Processing…</p>}
        {state === "ok" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-emerald-600 mx-auto" />
            <h1 className="mt-4 font-serif text-3xl text-emerald-950">You've unsubscribed</h1>
            <p className="mt-2 text-stone-500">You won't receive any more PlantFlow bulk emails. You can re-subscribe anytime in Settings.</p>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto" />
            <h1 className="mt-4 font-serif text-3xl text-emerald-950">Invalid link</h1>
            <p className="mt-2 text-stone-500">This unsubscribe link is invalid.</p>
          </>
        )}
        <Link to="/" className="mt-7 inline-block rounded-full bg-emerald-900 hover:bg-emerald-800 text-white px-6 py-2.5 text-sm">Back to home</Link>
      </div>
    </div>
  );
}
